import { useQuery } from "react-query";
import axios from "../services/Api/axiosConfigAuth";

const fetchMyVehicles = async () => {
  const { data } = await axios.get(
    "/api/v1/vehicle",
  );
  return data;
};

const useMyVehicles = () =>
  useQuery(["MyVehicles"], () => fetchMyVehicles());
export default useMyVehicles;
